// checkFn will be passed the current wait time if it wants to use it, but it doesn't have to
type CheckHandler = (time?: number) => any

/**
 * Retries an arbitrary function call with increasing delays between retries
 */
export function retryWithBackoff(
  wait = 5,
  maxWait = 1000,
  checkFn: CheckHandler = () => true,
  successFn = () => {},
  errorFn = () => {},
  adjustWaitFn = (t) => t * 2
): any {
  if (checkFn(wait)) {
    successFn()
    return
  }

  if (wait < maxWait) {
    setTimeout(() => {
      retryWithBackoff(
        adjustWaitFn(wait),
        maxWait,
        checkFn,
        successFn,
        errorFn,
        adjustWaitFn
      )
    }, wait)
    return
  }

  errorFn()
}

/**
 * Retries an arbitrary function call with increasing delays between retries
 */
export async function asyncRetryWithBackoff(
  wait = 5,
  maxWait = 1000,
  checkFn: CheckHandler = () => true,
  successFn = () => {},
  errorFn = () => {},
  adjustWaitFn = (t) => t * 2
): Promise<any> {
  if (await checkFn(wait)) {
    successFn()
    return
  }

  if (wait < maxWait) {
    setTimeout(() => {
      asyncRetryWithBackoff(
        adjustWaitFn(wait),
        maxWait,
        checkFn,
        successFn,
        errorFn,
        adjustWaitFn
      )
    }, wait)
    return
  }

  errorFn()
}
